import nsUiConfig from '@netsapiens/netsapiens-js/dist/ui-config';

export default ({
  domain,
  user,
  role,
  hostname,
  reseller,
}) => Promise.all([
  nsUiConfig.get({
    configName: 'ANALYTICS_*',
    domain,
    user,
    role,
    hostname,
    reseller,
  }),
  nsUiConfig.get({
    configName: 'PORTAL_*',
    domain,
    user,
    role,
    hostname,
    reseller,
    // todo config filter
  }),
]).then((res) => {
  const configs = {};

  if (res[0]) {
    res[0].forEach((config) => {
      configs[config.config_name] = config.config_value;
    });
  }

  res[1].forEach((config) => {
    if (config.config_name === 'PORTAL_SOCKET_HOSTNAME'
      && config.config_value
      && config.config_value.trim()
    ) {
      const tempWs = config.config_value.split(',');
      if (tempWs) {
        const nsSockets = [];
        for (let i = 0; i < tempWs.length; i += 1) {
          if (tempWs[i] && tempWs[i].trim()) {
            tempWs[i] = tempWs[i].trim();
            if (tempWs[i].indexOf(':') === -1) {
              nsSockets.push(`wss://${tempWs[i]}:8001`);
            } else {
              nsSockets.push(`wss://${tempWs[i]}`);
            }
          }
        }
        if (nsSockets) {
          configs.nsSocketURLs = nsSockets;
        }
      }
    } else {
      configs[config.config_name] = config.config_value;
    }
  });

  return configs;
});
